import { render, staticRenderFns } from "./InternalBans.vue?vue&type=template&id=0ece4079"
import script from "./InternalBans.vue?vue&type=script&lang=js"
export * from "./InternalBans.vue?vue&type=script&lang=js"
import style0 from "./InternalBans.vue?vue&type=style&index=0&id=0ece4079&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports